import { Elements, TextButton } from '@tfo/common'
import * as React from 'react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'
import DenyApprovalModal from '../../../../components/modals/deny-approval-modal/DenyApprovalModal'
import $http from '../../../../utils/$http'
import { ApprovableOrderViewModel } from '../../ViewModels'
import AboutBackgroundCheck from '../../common/about-background-check/AboutBackgroundCheck'
import IndividualInformationEditForm from './IndividualInformation'
import ScriveInfoModal from '../../../../components/modals/scrive-info-modal/ScriveInfoModal'
import './LegitimateInterestAssessmentInformation.scss'

const { Paragraph } = Elements

type LegitimateInterestAssessmentInformationProps = ApprovableOrderViewModel & {
    isLoading: boolean
    setIsLoading: (state: boolean) => void
}

const LegitimateInterestAssessmentInformation: React.FunctionComponent<LegitimateInterestAssessmentInformationProps &
    WrappedComponentProps> = (props) => {
        const { companyName, orderId, setIsLoading } = props
        const history = useHistory()

        const [showDenyApprovalModal, setShowDenyApprovalModal] = React.useState<boolean>(false)
        const [showNetworkError, setShowNetworkError] = React.useState<boolean>(false)
        const [showScriveInfoModal, setShowScriveInfoModal] = React.useState<boolean>(false)

        const applyApproval = (action: "approve" | "deny") => {
            setIsLoading(true)

            $http.post(`${action}/${orderId}`, null)
                .then(() => {
                    setShowNetworkError(false)
                    //go back to /candidate using history.goback() (edge case: if go back isn't /candidate)
                    history.goBack();
                })
                .catch(() => {
                    setShowNetworkError(true)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }

        const acceptOrder = () => applyApproval("approve")
        const denyOrder = async () => {
            if (props.approval.acceptanceMethod === "BankId") {
                applyApproval("deny")
            } else {
                $http.post(`signature/deny/${props.orderId}`, null).then(() => {
                    setShowNetworkError(false)
                    history.goBack()
                }).catch(() => {
                    setShowNetworkError(true)
                })
            }
        }

        const startSignature = async () => {
            const signatureLink = await $http.post<{ link: string }>(`signature/${props.orderId}/start`, null)
            window.location.href = signatureLink.link
        }

        return <>
            <div className="AboutBackgroundCheck">
                <Paragraph>
                    {
                        props.intl.formatMessage(
                            { id: 'startIndividual.body' },
                            { companyName })
                    }
                    <b>
                        {
                            props.intl.formatMessage({ id: 'startIndividual.body.bold' })
                        }
                    </b>
                </Paragraph>
            </div>
            <div className="AboutBackgroundCheck">
                <Paragraph>
                    {props.intl.formatMessage(
                        { id: 'startIndividual.body.partTwo' },
                        {
                            companyName: companyName,
                            link: (
                                <a
                                    href={props.intl.formatMessage({ id: 'common.tfoGdprPolicy.link-url' })}
                                    target='_blank' rel="noreferrer">
                                    {props.intl.formatMessage({ id: 'common.tfoGdprPolicy' })}{' '}
                                </a>
                            ),
                        },
                    )}
                </Paragraph>
            </div>
            <div className="AboutBackgroundCheck">
                <Paragraph>
                    {props.intl.formatMessage(
                        { id: 'startIndividual.body.part.deletion' },
                        { companyName: companyName }
                    )}
                </Paragraph>
            </div>
            <AboutBackgroundCheck order={props} />
            <div className="AboutBackgroundCheck">
                <Paragraph className="confirm-individual-information">
                    {props.intl.formatMessage(
                        { id: 'aboutbackgroundcheck.confirmIndividualInfo' },
                        { companyName: companyName })}
                </Paragraph>
                <IndividualInformationEditForm
                    individualInfo={props}
                />
            </div>
            <div className="AboutBackgroundCheck">
                <Paragraph>
                    {props.intl.formatMessage(
                        { id: 'aboutbackgroundcheck.beforeProceeding.4' },
                        {
                            company: companyName,
                            link: (
                                <a
                                    href={props.intl.formatMessage({ id: 'common.tfoGdprPolicy.link-url' })}
                                    target='_blank' rel="noreferrer" >
                                    {props.intl.formatMessage({ id: 'common.tfoGdprPolicy' })}{' '}
                                </a>
                            ),
                        },
                    )}
                </Paragraph>
            </div>
            <div className={'IndividualButtons'} >
                <TextButton
                    secondary={true}
                    className="StartIndividual__TextButton StartIndividual__TextButton--left"
                    onClick={() => {
                        setShowDenyApprovalModal(true)
                    }}>
                    {props.intl.formatMessage({ id: 'startIndividual.btn.deny' })}
                </TextButton>

                {props.approval.acceptanceMethod === "BankId" && <div>
                    <TextButton
                        className="StartIndividual__TextButton StartIndividual__TextButton--right lia-button-approve"
                        onClick={() => history.push(`/approval/${orderId}/bankid`)}>
                        {props.intl.formatMessage({
                            id: 'startIndividual.bankid.btn.approve',
                        })}
                    </TextButton>
                    <Paragraph className='lia-missing-bankid-info'>
                        <b>
                            {props.intl.formatMessage({ id: 'startIndividual.missingBankID.heading' })}
                        </b>
                        <button
                            type="button"
                            onClick={() => setShowScriveInfoModal(true)}
                            className="MissingBankIdButton"
                        >
                            {props.intl.formatMessage({ id: 'startIndividual.missingBankID.body' })}
                        </button>
                    </Paragraph>
                </div>
                }
                {props.approval.acceptanceMethod === "Scrive" && <TextButton
                    onClick={startSignature}
                    className="StartIndividual__TextButton StartIndividual__TextButton--right lia-button-approve">
                    {props.intl.formatMessage({ id: 'startIndividual.scrive.btn.approve' })}
                </TextButton>}
                {props.approval.acceptanceMethod === "Click" &&
                    <TextButton
                        className="StartIndividual__TextButton StartIndividual__TextButton--right"
                        onClick={acceptOrder}>
                        {props.intl.formatMessage({
                            id: 'startIndividual.btn.approve',
                        })}
                    </TextButton>}
            </div>
            <div className="AboutBackgroundCheck">
                {showNetworkError &&
                    <div className="InputErrorMessage">
                        {props.intl.formatMessage({ id: 'startIndividual.networkError' })}
                    </div>
                }
            </div>

            <div className="AboutBackgroundCheck">
                <Paragraph small >
                    {props.intl.formatMessage(
                        { id: 'startIndividual.footer' },
                        {
                            companyName: companyName,
                            link: (
                                <Link to="/faq">
                                    {props.intl.formatMessage({
                                        id: 'startIndividual.link.faq',
                                    })}
                                </Link>
                            ),
                        },
                    )}
                </Paragraph>
            </div>

            {showDenyApprovalModal ? (
                <DenyApprovalModal
                    onDenyClick={() => setShowDenyApprovalModal(false)}
                    onCloseClick={() => setShowDenyApprovalModal(false)}
                    onConfirmClick={denyOrder}
                    companyName={companyName}
                />
            ) : null}

            {showScriveInfoModal ? (
                <ScriveInfoModal
                    onCloseClick={() => setShowScriveInfoModal(false)}
                    companyName={companyName} />
            ) : null}
        </>
    }

export default injectIntl(LegitimateInterestAssessmentInformation)